import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { MessageService } from 'primeng/api';
//import * as FileSaver from 'file-saver';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { CasoClinico, CasoClinicoFormatoXLS } from 'src/app/models/caso-clinico.interface';
import { Medico } from 'src/app/models/medico.interface';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
import { RedimirEnfermera } from 'src/app/models/redimir.interface';
import { environment } from 'src/environments/environment';
import { Puntos } from 'src/app/models/catalogos.interface';
import { Distribuidor } from 'src/app/models/distribuidor.interface';

@Component({
  selector: 'app-administrador-enfermera',
  templateUrl: './administrador-enfermera.component.html',
  styleUrls: ['./administrador-enfermera.component.scss']
})
export class AdministradorEnfermeraComponent {
  showModal = false;
  idEnfermera: string = '0';
  enfermera!: Enfermera;
  casoclinicopuntos!: CasoClinico;
  distribuidores: Distribuidor[] = [];
  statusCanje: string[] = [...DESCRIPCION_STATUS_CANJE];
  currentPageCasosClinicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;

  currentPageMedicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsMedicos: number = 10;

  currentPageCanjes: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCanjes: number = 10;

  puntosForm!: FormGroup;
  productividadEnfermeraForm!: FormGroup;
  distribuidorForm!: FormGroup;

  catalogoPuntos: Puntos[] = [];
  accionPendiente: 'cancelar' | 'rechazar' | null = null;

  showModalAsignarVendedor: boolean = false;


  get casosClinicos(): CasoClinico[] {
    const startIndex = (this.currentPageCasosClinicos.page) * this.currentPageCasosClinicos.rows;
    return this.enfermera.casosclinicos.slice(startIndex, startIndex + this.currentPageCasosClinicos.rows);
  }

  get totalPaginasCasosClinicos(): number {
    return Math.ceil(this.enfermera.casosclinicos.length / this.currentPageCasosClinicos.rows);
  }
  get casosClinicosPagados(): number {
    return this.enfermera.casosclinicos.filter((item) => item.status_canje == 3).reduce((acumulador, item) => acumulador + item.e_puntos, 0)
  }
  get casosClinicosSaldo(): number {
    return this.enfermera.casosclinicos.filter((item) => item.status_canje == 0 || item.status_canje == 1 || item.status_canje == 2).reduce((acumulador, item) => acumulador + item.e_puntos, 0)
  }
  get canjesPagados(): number {
    return this.enfermera.canjes.filter((item) => item.status == 3).reduce((acumulador, item) => acumulador + item.redimir, 0)
  }
  get medicos(): Medico[] {
    const startIndex = (this.currentPageMedicos.page) * this.currentPageMedicos.rows;
    return this.enfermera.medicos.slice(startIndex, startIndex + this.currentPageMedicos.rows);
  }

  get totalPaginasMedicos(): number {
    return Math.ceil(this.enfermera.medicos.length / this.currentPageMedicos.rows);
  }

  get canjes(): RedimirEnfermera[] {
    const startIndex = (this.currentPageCanjes.page) * this.currentPageCanjes.rows;
    return this.enfermera.canjes.slice(startIndex, startIndex + this.currentPageCanjes.rows);
  }

  get totalPaginasCanjes(): number {
    return Math.ceil(this.enfermera.canjes.length / this.currentPageCanjes.rows);
  }

  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private messageService: MessageService,
    private administradorService: AdministradorService) {
    this.idEnfermera = this.activedRoute.snapshot.params['id'];
    this.obtenerInformacion(this.idEnfermera);
    this.puntosForm = this.crearFormulario();
    this.distribuidorForm = this.crearDistribuidorFormulario();
    this.productividadEnfermeraForm = this.crearFormularioProductividad();
  }
   get puntosCanjeados(): number {
    return this.enfermera.canjes.reduce((total, canje) => total + (canje.status == 3 ? canje.redimir : 0), 0);
  }
  get puntosGenerados(): number {
    return this.enfermera.casosclinicos.reduce((total, casoclinico) => total + (casoclinico.e_puntos ? casoclinico.e_puntos : 0), 0);
  }
  get saldo(): number {
    return this.enfermera.casosclinicos.reduce((total, casoclinico) => total + (casoclinico.status_canje != 3 ? (casoclinico.e_puntos ?? 0) : 0), 0);
  }
  crearFormularioProductividad(): FormGroup {
    return this.fb.group({
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required]
    })
  }
  crearFormulario(): FormGroup {
    return this.fb.group({
      puntos: [null, Validators.required],
      id: [null]
    })
  }
  crearDistribuidorFormulario(): FormGroup {
    return this.fb.group({
      nom_completo: [null],
      id: [null, Validators.required]
    })
  }
  obtenerInformacion(id: string): void {
    forkJoin({
      subEnfermera: this.administradorService.getEnfermera(id),
      // subDistribuidores: this.administradorService.getDistribuidores(),
      subEspecialidades: this.administradorService.getEspecialidades(),
    }).subscribe({
      next: (resp) => {
        this.fullEnfermera(resp.subEnfermera.datos);
        // this.fullDistribuidores(resp.subDistribuidores);
        this.showSuccess(resp.subEnfermera.mensaje);
      },
      error: (err) => { console.log(err) }
    });
  }
  fullEnfermera(enfermera: Enfermera): void {
    this.enfermera = enfermera;
    this.asignarTotales(enfermera);
  }
  fullDistribuidores(distribuidores: Distribuidor[]): void {
    this.distribuidores = distribuidores;
  }
  asignarTotales(enfermera: Enfermera): void {
    this.totalItemsCasosClinicos = enfermera.casosclinicos.length;
    this.totalItemsMedicos = enfermera.medicos.length;
    this.totalItemsCanjes = enfermera.canjes.length;
  }

  onPageChangeCasosClinicos(event: any) {
    this.currentPageCasosClinicos = <Paginar>event;
  }

  onPageChangeMedicos(event: any) {
    this.currentPageMedicos = <Paginar>event;
  }

  onPageChangeCanjes(event: any) {
    this.currentPageCanjes = <Paginar>event;
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  getCanje(id: number): string {
    return this.statusCanje[id];
  }

  formatDateISO(date: Date) {
    // Convert the date to ISO string
    const isoString = date.toISOString();
    // Split at the "T" character to get the date part
    const formattedDate = isoString.split("T")[0];
    return formattedDate;
  }

  exportPDF(): void {
    const fechas = this.productividadEnfermeraForm.value;
    const fechaInicio = this.formatDateISO(fechas.fechaInicio);
    const fechaFin = this.formatDateISO(fechas.fechaFin);

    const url = environment.urlbase + environment.pdfs.productividadEnfermera + this.idEnfermera + `/${fechaInicio}/${fechaFin}`;

    window.open(url, '_blank');
  }

  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const casosClinicos: CasoClinicoFormatoXLS[] = this.fullCasosClinicosXLSX(this.enfermera.casosclinicos);
    const nombreEnfermera = [{ campo: "Enfermera", nomEnfermera: this.enfermera.nom_enfermera }];
    const fileName = 'enfermera-casosclinicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, nombreEnfermera, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, casosClinicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'casos_clinicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  fullCasosClinicosXLSX(casoclinico: CasoClinico[]): CasoClinicoFormatoXLS[] {
    const casosclinicosxlsx: CasoClinicoFormatoXLS[] = casoclinico.map((item) => {
      return <CasoClinicoFormatoXLS>{
        fecha: item.fecha,
        folio: item.folio,
        serie: item.serie,
        paciente: item.paciente,
        sexo: item.sexo,
        edad: item.edad,
        antecedente: item.antecedente,
        institucion: item.cveInstitucion,
        hospital: item.nomHospital,
        fechaAplicacionProducto: item.fechaAplicacionProducto,
        diagnostico: item.diagnostico,
        antibiotico1: item.nomAntibiotico1,
        cantidad1: item.cantidad1,
        antibiotico2: item.nomAntibiotico2,
        cantidad2: item.cantidad2,
        antibiotico3: item.nomAntibiotico3,
        cantidad3: item.cantidad3,
        tratamiento: item.tratamiento,
        cuerpo: item.nomCuerpo,
        observacion: item.observacion,
        status: this.statusCanje[item.status_canje],
        medico: item.medico.nom_medico,
        productos: item.productos.length,
        documentos: item.documentos.length
      }
    });
    return casosclinicosxlsx;
  }

  cancelarAccion(): void {
    this.resetForm();
    this.catalogoPuntos = [];
    this.closeModal();
  }

  closeModal(): void {
    this.showModal = false;
    this.accionPendiente = null;
  }
  openModal(): void {
    this.accionPendiente = 'rechazar';
    this.showModal = true;
  }
  openModalAsignar(): void {
    this.showModalAsignarVendedor = true;
  }
  closeModalAsignar(): void {
    this.showModalAsignarVendedor = false;
  }
  resetFormAsignar(): void {
    this.distribuidorForm.reset();
  }
  resetForm(): void {
    this.puntosForm.reset();
  }
  onSubmit(): void {
    const puntos: Puntos = this.puntosForm.get('puntos')?.value;
    const id = this.puntosForm.get('id')?.value;

    this.administradorService.asignarPuntosCasoClinico(this.casoclinicopuntos.id, puntos.puntos)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.casoclinicopuntos.e_puntos = puntos.puntos;
          this.closeModal();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
        }

      })

  }
  onSubmitAsignarVendedor(): void {
    //console.log(this.distribuidorForm.value, this.idEnfermera);
    let id_distribuidor = this.distribuidorForm.value.id;
    let id_enfermera = this.idEnfermera;
    let distribuidor: Distribuidor | undefined = this.distribuidores.find(item => item.id == id_distribuidor);

    if (distribuidor) {

      this.administradorService
        .asignarDistribuidorAlaEnfermera({ fk_distribuidor: id_distribuidor, fk_enfermera: id_enfermera })
        .subscribe({
          next: (resp) => {
            this.enfermera.distribuidor = distribuidor;
            this.showSuccess(resp.mensaje);
            this.closeModalAsignar();
          },
          error: (err) => { }
        })
    }
  }
  asignarpuntos(casoclinico: CasoClinico): void {

    this.administradorService.catalogoPuntos()
      .subscribe({
        next: (resp) => {
          this.catalogoPuntos = resp;
          this.casoclinicopuntos = casoclinico;
          this.openModal();
        },
        error: (err) => {
          console.log(err);
        }
      });

  }

  asignarDistribuidor(enfermera: Enfermera): void {
    this.openModalAsignar();
    //  alert(enfermera.nom_enfermera);
  }
  cancelarAccionAsignacionVendedor(): void {
    this.closeModalAsignar();
    this.resetFormAsignar();
  }
  regresar(): void {
    this.router.navigate(['/administrador/enfermeras'])
  }

}
